<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      <span v-if="title == '离线翻译'">{{ $t("OffLineResult.title1") }}</span>
      <span v-if="title == '音/视频通话'">{{
        $t("OffLineResult.title2")
      }}</span>
      <span v-if="title == '基础服务'">{{ $t("OffLineResult.title3") }}</span>
    </div>
    <div>
      <div>
        <div class="result-title" v-if="show2 || show3">
          <img class="success-img" :src="successImage" alt="" />
          {{ $t("OffLineResult.paySuccess") }}
        </div>
        <div v-if="show2" class="result-tip">
          {{ $t("OffLineResult.saveTitle") }}
        </div>
        <div v-if="show3" class="result-tip">
          {{ $t("OffLineResult.stock") }}
        </div>
      </div>

      <div>
        <div
          :class="{ 'result-content': true }"
          v-for="(item, index) in redeemCodes"
          :key="index"
        >
          <div class="result-content-title">{{ $t("OffLineResult.code") }}</div>
          <div class="qr-container">
            <canvas
              :ref="(el) => setItemRef(el, index)"
              :style="{ width: size + 'px', height: size + 'px' }"
            ></canvas>
          </div>
          <div class="result-text">
            {{ item }}
            <span class="copy" @click="handleCopy(item)">{{
              $t("OffLineResult.copy")
            }}</span>
          </div>
          <div class="line1"></div>
          <div class="tip">
            <div style="padding-bottom: 8px">
              <span v-if="title == '离线翻译'">
                {{ $t("OffLineResult.tip1") }}
              </span>
              <span v-if="title == '音/视频通话'">
                {{ $t("OffLineResult.tip2") }}
              </span>
              <span v-if="title == '基础服务'">
                {{ $t("OffLineResult.tip3") }}
              </span>
            </div>
            <div>{{ $t("OffLineResult.time") }}{{ purchaseTime }}</div>
          </div>
          <div>
            <el-button
              type="primary"
              class="save-button"
              @click="saveQRCode(index)"
              >{{ $t("OffLineResult.save") }}</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="message" v-if="show">
      <div class="tip1">{{ message }}</div>
    </div>
    <div
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
      v-if="show1"
    >
      {{ $t("OffLineResult.loading") }}
    </div>
  </div>
</template>
    
    <script>
import QRCode from "qrcode"; // 引入库
import {
  getTransactionOrders,
  getTransactionRedeemCodes,
} from "@/api/login/user";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "OffLineResult",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show3: false,
      itemRefs: {},
      batchNo: "",
      title: "",
      size: 150,
      bgColor: "#ffffff",
      color: "#000",
      content: "generateQRCode",
      orderID: "",
      redeemCode: "",
      redeemCodes: [],
      purchaseTime: "",
      stripe: "",
      publishableKey: "",
      show: false,
      show1: false,
      show2: false,
      message: "",
      RedemptionCode: "YUJH7273889",
      closeImage: require("@/assets/close.png"),
      successImage: require("@/assets/success.png"),
      QRCodeImg: require("@/assets/QRCode.png"),
      lang: "cn",
      height1: "385px",
      intervalId: null, // 用于保存定时器 ID
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      if (val == "en") {
        this.message = "success";
      }
      this.getStyle();
    },
    content: "generateQRCode111",
  },
  async mounted() {
    this.title = localStorage.getItem("resultTitle");
    this.lang = localStorage.getItem("lang");
    this.orderID = localStorage.getItem("orderNumber");
    this.getStyle();
    this.show1 = true;
    this.publishableKey = localStorage.getItem("publishableKey")
    if(!this.publishableKey) return
    this.stripe = await loadStripe(this.publishableKey);
    this.clientSecret = this.$route.query.payment_intent_client_secret;
    this.intervalId = setInterval(this.getRedeemCodesNet, 5000);
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getRedeemCodesNet() {
      const { paymentIntent } = await this.stripe.retrievePaymentIntent(
        this.clientSecret
      );
      if (paymentIntent && paymentIntent.status === "succeeded") {
        const params = {
          productType: "",
          orderID: this.orderID,
          page: 1,
          limit: 10,
          expandOrderType:"exchange"
        };
        await getTransactionOrders(params).then(async (res) => {
          if (res?.data) {
            this.batchNo = res.data[0]?.metadata?.batch_no;
            this.purchaseTime = res.data[0]?.purchaseTime;
            if (!res.data[0]?.metadata) {
              this.show3 = false;
              return;
            }
            if (!this.batchNo) return;
            await getTransactionRedeemCodes({
              batchNo: this.batchNo,
            }).then((res) => {
              if (res?.data) {
                res.data.forEach((item) => {
                  this.redeemCodes.push(item.code);
                  this.redeemCodes = [...new Set(this.redeemCodes)];
                  this.show2 = true;
                  this.show1 = false;
                });
              }
            });
          }
        });
      }
      if (
        paymentIntent.status === "requires_action" ||
        paymentIntent.status === "requires_payment_method"
      ) {
        this.show = true;
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.message = this.$t("OffLineResult.fail");
        setTimeout(() => {
          this.show = false;
          this.$router.back();
        }, 1000);
        return
      }
      setTimeout(() => {
        if (this.redeemCodes && this.redeemCodes.length != 0) {
          this.redeemCodes.forEach((item, index) => {
            const canvas = this.itemRefs[index];
            QRCode.toCanvas(canvas, item, {
              width: this.size,
              color: {
                dark: this.color, // 深色模块颜色
                light: this.bgColor, // 浅色模块颜色
              },
              errorCorrectionLevel: "H", // 容错等级 (L/M/Q/H)
            });
          });
          this.show2 = true;
          this.show1 = false;
          this.show3 = false;
        } else {
          this.show3 = true;
          this.show1 = false;
        }
      }, 1000);
      
      if (this.batchNo && this.redeemCodes.length != 0) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      }
    },
    setItemRef(el, index) {
      if (el) {
        // 将引用按索引存储到对象中
        this.itemRefs[index] = el;
      }
    },
    saveQRCode(index) {
      const canvas = this.itemRefs[index];
      if (!canvas) {
        return;
      }
      const base64Text = canvas.toDataURL("image/png");
      const blob = this.getBlob(base64Text);
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, "qrcode.png");
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "qrcode.png";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }, 100);
      }
    },
    getBlob(base64) {
      const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
      const byteString = atob(base64.split(",")[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const intArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], { type: mimeString });
    },
    generateQRCode() {
      this.$nextTick(() => {
        const canvas = this.$refs.qrCanvas;
        QRCode.toCanvas(canvas, this.redeemCode, {
          width: this.size,
          color: {
            dark: this.color, // 深色模块颜色
            light: this.bgColor, // 浅色模块颜色
          },
          errorCorrectionLevel: "H", // 容错等级 (L/M/Q/H)
        });
      });
    },
    getStyle() {
      if (this.lang == "cn" || this.lang == "tw") {
        this.height1 = "385px";
      }
      const list = ["en", "ru", "es", "fr", "it", "pt", "tr", "vi", "id", "hi"];
      if (list.includes(this.lang)) {
        this.height1 = "405px";
      } else {
        this.height1 = "385px";
      }
      if (this.lang == "de") {
        this.height1 = "418px";
      }
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    handleCopy(val) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(val)
          .then(() => {
            this.show = true;
            this.message = this.$t("OffLineResult.copySuccess");
            setTimeout(() => {
              this.show = false;
            }, 1000);
          })
          .catch((err) => {
            this.show = true;
            this.message = err;
            setTimeout(() => {
              this.show = false;
            }, 1000);
            console.error("Failed to copy text: ", err);
          });
        return;
      }

      if (document.execCommand) {
        console.log("document.execCommand---copy");

        const textArea = document.createElement("textarea");
        textArea.setAttribute("readonly", "readonly");
        textArea.value = val;
        document.body.appendChild(textArea);
        textArea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (successful) {
          this.show = true;
          this.message = this.$t("OffLineResult.copySuccess");
          setTimeout(() => {
            this.show = false;
          }, 1000);
        } else {
          this.show = true;
          this.message = "copy failed";
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      } else {
        console.log("Failed to copy---document.execCommand---not");
      }
    },
  },
};
</script>
    
    <style scoped>
#app {
  height: 100vh;
  text-align: left;
  background: #f5f5f5;
  /* padding-bottom: 24px; */
  overflow: auto;
  padding: 0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.result-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  text-align: center;
  margin: 40px 0px 16px 0px;
}
.success-img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 16px;
}
.result-tip {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  text-align: center;
  margin-bottom: 32px;
}
.result-content {
  width: 100%;
  /* min-height: 385px; */
  border-radius: 16px;
  background: #ffffff;
  text-align: center;
  padding-bottom: 24px;
  margin-top: 24px;
}
.result-content1 {
  width: 100%;
  height: 405px;
  border-radius: 16px;
  background: #ffffff;
  text-align: center;
}
.result-content-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding-top: 16px;
}
.QRCodeImg {
  width: 125px;
  height: 125px;
}
.result-text {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 16px;
}
.copy {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 品牌色 */
  color: #f65e3d;
  cursor: pointer;
}
.line1 {
  width: 90%;
  height: 0px;
  border-top: 1px dashed #d8d8d8;
  text-align: center;
  margin: 0 auto;
}
.tip {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  text-align: left;
  padding: 16px;
}
.save-button {
  width: calc(100% - 32px);
  height: 44px;
  border-radius: 8px;
}
.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
}
.tip1 {
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}
</style>
    